// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"P1dY9","mediaWrapper":"DYA1G","text":"iByV5","title":"S034r","media":"lucEp","caption":"_9dwpL","callout":"+PVf-","only-text":"_0qlAw","mediaWrapperHalf":"yVSiL"};